import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const SuitcaseIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M11.5.583H4.667v3.334H2.083C.933 3.917 0 4.849 0 6v7.333c0 1.15.932 2.083 2.083 2.083h12c1.15 0 2.083-.932 2.083-2.083V6c0-1.15-.933-2.083-2.083-2.083H11.5zm.5 4.834H4.166v8.5H12zm1.5 8.5h.583a.583.583 0 0 0 .583-.584V6a.583.583 0 0 0-.583-.583h-.584zm-11.417-8.5h.583v8.5h-.583a.583.583 0 0 1-.583-.584V6c0-.322.26-.583.583-.583M10 3.916V2.084H6.167v1.833z"
      clipRule="evenodd"
    />
  </svg>
);
SuitcaseIcon.id = 'SuitcaseIcon';
SuitcaseIcon.displayName = 'SuitcaseIcon';
export default SuitcaseIcon;
